module.exports = __webpack_public_path__ + "img/salesforce.31d2b1a0.jpg";